import * as R from 'ramda';

import queryString from 'query-string';

export function inIframe() {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
}

export const isIframeMode = queryString.parse(location.search)['iframe-mode'];

export const urlIframeMode = url => (isIframeMode ? `${url}?iframe-mode=true` : url);

export function getJsonFromUrl() {
    const query = location.search.substr(1);
    const result = {};
    query.split('&').forEach(function(part) {
        const item = part.split('=');
        result[item[0]] = decodeURIComponent(item[1]);
    });
    return result;
}

export function submitForm(verb, url, data, target) {
    const form = document.createElement('form');
    form.action = url;
    form.method = verb;
    form.target = target || '_self';
    if (data) {
        for (const key in data) {
            const input = document.createElement('textarea');
            input.name = key;
            input.value = typeof data[key] === 'object' ? JSON.stringify(data[key]) : data[key];
            form.appendChild(input);
        }
    }
    form.style.display = 'none';
    document.body.appendChild(form);
    form.submit();
}

/** @returns {Record<string, string>} */
export const getHashObject = () =>
    R.pipe(
        R.replace('#', ''),
        R.ifElse(
            R.isEmpty,
            R.always({}),
            R.pipe(
                R.split('&'),
                R.map(R.split(':')),
                R.fromPairs
            )
        )
    )(window.location.hash);


/**
 * @param {Object} object
 */
export const updateHash = (object) =>
    R.pipe(
        R.merge(getHashObject()),
        R.toPairs,
        R.map(R.join(':')),
        R.join('&')
    )(object);



// WEBPACK FOOTER //
// ./common/url_helper.js